import {
  IconSize,
  iconStrokeWidthBySize,
  IconStyle,
  ShieldIconSize,
} from '../../icon_types';

type ShieldCheckIconProps = {
  id?: string;
  className?: string;
  size: IconSize | ShieldIconSize;
  color?: string;
  checkColor?: string;
  style: IconStyle;
};

const pathDsByStyleAndSize = {
  '8': [
    'M3.99992 7.33335C3.99992 7.33335 6.66659 6.00002 6.66659 4.00002V1.66669L3.99992 0.666687L1.33325 1.66669V4.00002C1.33325 6.00002 3.99992 7.33335 3.99992 7.33335Z',
    'M5.18182 3L3.68182 4.5L3 3.81818',
  ],
  '16': [
    'M8.63656 14.6666C8.63656 14.6666 13.9699 12 13.9699 7.99998V3.33331L8.63656 1.33331L3.30322 3.33331V7.99998C3.30322 12 8.63656 14.6666 8.63656 14.6666Z',
    'M11.0001 6L8.00011 9L6.63647 7.63636',
  ],
  '24': [
    'M12.6365 22C12.6365 22 20.6365 18 20.6365 12V5L12.6365 2L4.63647 5V12C4.63647 18 12.6365 22 12.6365 22Z',
    'M16.1819 9L11.6819 13.5L9.63647 11.4545',
  ],
  '32': [
    'M16.6364 29.3334C16.6364 29.3334 27.3031 24 27.3031 16V6.66669L16.6364 2.66669L5.96973 6.66669V16C5.96973 24 16.6364 29.3334 16.6364 29.3334Z',
    'M21.3637 12L15.3637 18L12.6365 15.2727',
  ],
};

const ShieldCheckIcon = (props: ShieldCheckIconProps) => {
  const {id, className, size, color, checkColor, style} = props;
  const paths = pathDsByStyleAndSize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      <path
        key={0}
        d={paths[0]}
        stroke={colorOptions}
        fill={style === 'filled' ? colorOptions : 'none'}
        strokeWidth={iconStrokeWidthBySize[size]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        key={1}
        d={paths[1]}
        stroke={style === 'outline' ? colorOptions : checkColor || 'white'}
        fill={style === 'filled' ? colorOptions : 'none'}
        strokeWidth={iconStrokeWidthBySize[size]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* <path
        key={2}
        d={paths[2]}
        stroke={style === 'outline' ? colorOptions : 'none'}
        fill={style === 'filled' ? colorOptions : 'none'}
        strokeWidth={iconStrokeWidthBySize[size]}
        strokeLinecap="round"
        strokeLinejoin="round"
      /> */}
    </svg>
  );
};

export default ShieldCheckIcon;
